export default "__VITE_ASSET__V9iTr2pT__"